<template>
  <div class="ScreenSwiper-container" ref="container" :style="style">
    <slot />
  </div>
</template>

<script>
export default {
  name: 'ScreenSwiper',
  props: {
    registrationPercentThreshold: {
      type: Number,
      default: 30
    },
    maxSwipe: {
      type: Number,
      default: 45
    },
    left: {
      type: Boolean,
      default: false
    },
    right: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      start: null,
      diff: 0,
      initialDocumentOverflow: null,
      initialDocumentWidth: null
    }
  },
  mounted() {
    this.initialDocumentOverflow = document.body.style.overflowX
    document.body.style.overflowX = 'hidden'

    this.initialDocumentWidth = document.body.style.width
    document.body.style.width = window.screen.width

    this.$refs.container.addEventListener('touchstart', this.handleToucheStart)
    this.$refs.container.addEventListener('touchmove', this.handleToucheMove)
    this.$refs.container.addEventListener('touchend', this.handleToucheEnd)
  },
  beforeDestroy() {
    document.body.style.overflowX = this.initialDocumentOverflow
    document.body.style.width = this.initialDocumentWidth

    this.$refs.container.removeEventListener('touchstart', this.handleToucheStart)
    this.$refs.container.removeEventListener('touchmove', this.handleToucheMove)
    this.$refs.container.removeEventListener('touchend', this.handleToucheEnd)
  },
  computed: {
    style() {
      return {
        transform: `translateX(${-this.diff}px)`
      }
    },
    threshold() {
      const { width } = window.screen

      return width * (this.registrationPercentThreshold / 100)
    },
    maxThreshold() {
      const { width } = window.screen

      return width * (this.maxSwipe / 100)
    }
  },
  methods: {
    /**
     * @param {TouchEvent} event
     */
    handleToucheStart(event) {
      this.start = event.touches[0]
    },
    /**
     * @param {TouchEvent} event
     */
    handleToucheMove(event) {
      const current = event.touches[0]
      const diffY = this.start.clientY - current.clientY

      let diffX = this.start.clientX - current.clientX

      /**
       * Reset animation for long vertical scroll (finger might drift and be registered as swipe)
       */
      if (Math.abs(diffX) < Math.abs(diffY)) {
        diffX = 0
      }

      // Prevent scroll left if disabled
      if (diffX < 0 && !this.left) {
        diffX = 0
      }

      // Prevent scroll right if disabled
      if (diffX > 0 && !this.right) {
        diffX = 0
      }

      // Prevent max scroll threshold to be bypassed
      if (Math.abs(diffX) >= this.maxThreshold) {
        diffX = diffX > 0 ? this.maxThreshold : this.maxThreshold * -1
      }

      requestAnimationFrame(() => {
        this.diff = diffX
      })
    },
    handleToucheEnd() {
      requestAnimationFrame(() => {
        let direction = null

        if (this.diff > this.threshold) {
          this.$emit('swiped-right')
          direction = 'right'
        }

        if (-this.diff > this.threshold) {
          this.$emit('swiped-left')
          direction = 'left'
        }

        if (direction) {
          this.$emit('swiped', direction)
        }

        this.diff = 0
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.ScreenSwiper-container {
  transition-duration: 70ms;
}
</style>
